import * as React from "react";
import { NumberFormatUtil } from "../../../../utils/advanced-list.constant";
import { FieldConfiguration } from "@amzn/ask-legal-domain";

export const NumberFieldView = (props: {
  numberFieldValue: string;
  fieldConfiguration?: FieldConfiguration.Number;
}) => {
  return (
    NumberFormatUtil.numberRegex.test(props.numberFieldValue) && (
      <>
        {props.fieldConfiguration
          ? NumberFormatUtil.formatNumber(
              props.numberFieldValue! as any as number,
              props.fieldConfiguration.format,
              props.fieldConfiguration.currency
            )
          : props.numberFieldValue}
      </>
    )
  );
};
